An array of positions to synchronize.

At least one position must be provided.
